var map = {
	"./ACCOBAMS_logo.png": "4ce4",
	"./CTN-logo.png": "6d4a",
	"./Logo QUIETSEAS_w.png": "ccb0",
	"./boat-top.jpg": "412d",
	"./comision-europea-logo.png": "636b",
	"./ctn_logo.png": "8097",
	"./dolphins.jpg": "33b6",
	"./download_data.jpg": "5b86",
	"./download_data_dark.png": "16fa",
	"./environmental.jpg": "6991",
	"./eu-commission-logo.jpg": "3add",
	"./european-comision-logo-en.svg": "6aa5",
	"./logo_europeo.png": "00bc",
	"./mediterranean-sea.jpg": "4f67",
	"./ola.jpg": "dcdc",
	"./qs-partners-map.png": "8b21",
	"./quietseas-logo-blue.png": "a2d2",
	"./quietseas-logo-color.png": "e15a",
	"./quietseas-logo-white.png": "4ca7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";